// AddItemComps/FileUpload.js
import React, { useState } from 'react';
import LightBox from '../../../LightBox/LightBox'
import './FileUpload.css';
import { useFileContext } from '../../../../../Context/FileContext';

const FileUpload = ({ label, placeholder }) => {
    const { files, addFiles, removeFile } = useFileContext();
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        addFiles(newFiles);
    };

    const handleFileDelete = (index) => {
        removeFile(index);
    };

    const openLightbox = (index) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);

    const showNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % files.length);
    };

    const showPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + files.length) % files.length);
    };

    return (
        <div>
            <input
                type="file"
                multiple
                accept="image/*,video/*"
                onChange={handleFileChange}
                id="file-upload"
                style={{ display: 'none' }}
            />
            <label htmlFor="file-upload" className="file-upload-label">
                {label}
            </label>

            <div className="file-previews">
                {files.map((file, index) => (
                    <div key={index} style={{ position: 'relative', display: 'inline-block', margin: '5px' }}>
                        {file.type.startsWith('image/') ? (
                            <img
                                src={URL.createObjectURL(file)}
                                alt={`preview-${index}`}
                                style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                                onClick={() => openLightbox(index)}
                            />
                        ) : (
                            <video
                                src={URL.createObjectURL(file)}
                                controls
                                style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                                onClick={() => openLightbox(index)}
                            />
                        )}
                        <button
                            onClick={() => handleFileDelete(index)}
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                background: 'red',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                cursor: 'pointer',
                            }}
                        >
                            X
                        </button>
                    </div>
                ))}
            </div>

            {lightboxOpen && (
                <LightBox
                    files={files}
                    currentIndex={currentIndex}
                    onClose={closeLightbox}
                    onNext={showNext}
                    onPrev={showPrev}
                />
            )}
        </div>
    );
};

export default FileUpload;
